import React from "react";
import iconBaremetal from "../../images/icons/icon-baremetal.svg";
import iconBaremetal1 from "../../images/icons/icon-baremetal-1.svg";
import iconBaremetal2 from "../../images/icons/icon-baremetal-2.svg";
import iconBaremetal3 from "../../images/icons/icon-baremetal-3.svg";
import iconBaremetal4 from "../../images/icons/icon-baremetal-4.svg";
import iconBaremetalStatus from "../../images/icons/icon-baremetal-status.svg";
import iconBaremetalConsole from "../../images/icons/icon-baremetal-console.svg";
import iconBaremetalReport from "../../images/icons/icon-baremetal-report.svg";
import imageHighlightBaremetalStatus from "../../images/image-highlight-baremetal-status.png";
import imageHighlightBaremetalConsole from "../../images/image-highlight-baremetal-console.png";
import imageHighlightBaremetalReport from "../../images/image-highlight-baremetal-report.png";
import Section from "../../components/ui/Section";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import ServiceAddedValueSection from "../../components/ui/PageSections/ServiceAddedValueSection";
import ServiceHighlightsSection from "../../components/ui/PageSections/ServiceHighlightsSection";
import { navigate } from "gatsby";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";
import PrimaryInputTable from "../../components/ui/InputTables/PrimaryInputTable";

const BaremetalPageTemplate = ({ pageContext, translations }) => {
	//Baremetal highlights
	const serviceHighlightsList = [
		{
			title: translations["BaremetalhighlightOneTitle"],
			text: translations["BaremetalhighlightOneText"],
			icon: (
				<img
					className="group-hover:fill-ipxonMagenta w-6 h-6 p-[2px] opacity-[.6]"
					src={iconBaremetalStatus}
					alt="Cog with a person icon inside"
				/>
			),
			image: (
				<img
					className="rounded-[10px] w-full"
					src={imageHighlightBaremetalStatus}
					alt="Snapshot of a service"
				/>
			),
		},
		{
			title: translations["BaremetalhighlightTwoTitle"],
			text: translations["BaremetalhighlightTwoText"],
			icon: (
				<img
					className="group-hover:fill-ipxonMagenta  w-6 h-6 p-[2px] opacity-[.6]"
					src={iconBaremetalConsole}
					alt="Cog with arrow pointing right"
				/>
			),
			image: (
				<img
					className="rounded-[10px] w-full"
					src={imageHighlightBaremetalConsole}
					alt="Code in a terminal"
				/>
			),
		},
		{
			title: translations["BaremetalhighlightThreeTitle"],
			text: translations["BaremetalhighlightThreeText"],
			icon: (
				<img
					className="group-hover:fill-ipxonMagenta  w-6 h-6 p-[2px] opacity-[.6]"
					src={iconBaremetalReport}
					alt="Pie chart"
				/>
			),
			image: (
				<img
					className="rounded-[10px] w-full"
					src={imageHighlightBaremetalReport}
					alt="Report of resources with graphics of a service"
				/>
			),
		},
	];

	return (
		<div className=" flex flex-col" id="BaremetalInputSection">
			<PageHeroSection
				heroTitle={
					translations["BaremetalMainTitle"]
						? translations["BaremetalMainTitle"]
						: pageContext.h1Title
				}
				subtitle={
					translations["BaremetalSubtitle"]
						? translations["BaremetalSubtitle"]
						: pageContext.h2Title
				}
				heroIcon={iconBaremetal}
				heroIconAltText="White rombus rack icon"
				intro={translations["BaremetalIntro"]}
			/>

			<PrimaryInputTable
				serviceType="baremetal"
				defaultIataCode={pageContext.iataCode}
				translations={translations}
				pageContext={pageContext}
				urlTranslations={pageContext.urlTranslations}
			/>

			<Section skewed="bottom">
				<div className="w-full flex flex-col xl:flex-row xl:gap-0">
					<div className="relative container w-full xl:w-2/5">
						<ServiceAddedValueSection
							secondaryTitle="BaremetalAddedValueSmallTitle"
							title="BaremetalAddedValueTitle"
							subTitle="BaremetalAddedValueSubtitle"
							serviceTabs={[
								{
									title: "BaremetalAddedValueTitleOne",
									content: "BaremetalAddedValueTextOne",
								},
								{
									title: "BaremetalAddedValueTitleTwo",
									content: "BaremetalAddedValueTextTwo",
								},
								{
									title: "BaremetalAddedValueTitleThree",
									content: "BaremetalAddedValueTextThree",
								},
								{
									title: "BaremetalAddedValueTitleFour",
									content: "BaremetalAddedValueTextFour",
								},
							]}
							translations={translations}
						/>
					</div>
					<div className="bg-gray-100 p-4 md:p-8 rounded-lg xl:w-3/5 max-w-[600px] m-auto h-fit mt-16 xl:mt-0">
						<span className="border-2 cursor-default relative text-xs font-bold inline-flex items-start rounded-md py-0.5 px-2 z-0 border-black text-black">
							{translations["BaremetalStatsLabel"]}
						</span>
						<p className="my-8 text-sm text-ipxon-medium-dark-gray">
							{translations["BaremetalAddedValueText"]}
						</p>
						<ul className="grid grid-cols-2 w-full gap-8">
							{[
								{
									icon: iconBaremetal1,
									title: "BaremetalStatOneTitle",
									text: "BaremetalStatOneText",
								},
								{
									icon: iconBaremetal2,
									title: "BaremetalStatTwoTitle",
									text: "BaremetalStatTwoText",
								},
								{
									icon: iconBaremetal3,
									title: "BaremetalStatThreeTitle",
									text: "BaremetalStatThreeText",
								},
								{
									icon: iconBaremetal4,
									title: "BaremetalStatFourTitle",
									text: "BaremetalStatFourText",
								},
							].map((serviceStat) => (
								<li
									className="flex flex-col gap-2 text-sm text-ipxon-black"
									key={serviceStat.title}
								>
									<img
										src={serviceStat.icon}
										alt="Stats Icon"
										className="h-[30px] md:h-[30px] w-[30px]"
									/>
									<div className="flex flex-col">
										<h5 className="font-bold text-sm">
											{translations[serviceStat.title]}
										</h5>
										<p className="text-sm">
											{translations[serviceStat.text]}
										</p>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
			</Section>
			<Section color="transparent">
				<ServiceHighlightsSection
					title={translations["BaremetalhighlightsTitle"]}
					subtitle={translations["BaremetalhighlightsSmallTitle"]}
					text={translations["BaremetalhighlightsSubtitle"]}
					highlights={serviceHighlightsList}
					defaultImage={
						<img
							className="rounded ServiceHighlights border-opacity-50 border border-gray-500"
							src={imageHighlightBaremetalStatus}
							alt="Interface showing a service and its status as well as buttons to control the service"
						/>
					}
					theme="primary"
					buttonText={translations["BaremetalhighlightsButtonText"]}
					onClickHandler={() => {
						navigate("#BaremetalInputSection");
					}}
				/>

				<EmpowerServicesSection translations={translations} />
			</Section>
			<Section>
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["BaremetalContactUsBannerTittle"]}
					subtitle={translations["BaremetalContactUsBannerSubTittle"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default BaremetalPageTemplate;
